// 작업 공간 전환 (IMP-5)
//
// ⚠️ **작업 공간이 하나면 아무것도 렌더하지 않는다.** 개인 사용자에게 '조직'이라는
// 개념이 새면 안 된다 — B2B를 지원한다고 B2C 경험이 복잡해지는 것이 이 기능의 실패다(설계 §8).
//
// 전환하면 서버가 새 토큰을 준다(테넌트가 JWT 클레임에 있다). 토큰을 갈아 끼운 뒤
// 화면 전체를 다시 읽어야 한다 — 목록·사용량·통계가 모두 테넌트 기준이기 때문이다.
import { useEffect, useState } from "react";
import { activeTenantId, tenantApi, type TenantSummary } from "../api/tenants.ts";
import { ApiError } from "@taplink/web-shared";
import { useAuth } from "@taplink/web-shared";

export function TenantSwitcher() {
  const { me, applyToken } = useAuth();
  const [tenants, setTenants] = useState<TenantSummary[]>([]);
  const [switching, setSwitching] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    void tenantApi.list().then(setTenants).catch(() => setTenants([]));
  }, [me]);

  // 하나뿐이면 존재를 드러내지 않는다
  if (tenants.length < 2) return null;

  const current = tenants.find((t) => t.id === activeTenantId(tenants));

  const onSwitch = async (tenantId: number) => {
    if (switching) return;
    setSwitching(true);
    setError(null);
    try {
      const token = await tenantApi.switch(tenantId);
      await applyToken(token.accessToken);
      // 테넌트가 바뀌면 화면의 모든 데이터가 달라진다 — 부분 갱신보다 전체 재적재가 안전하다
      window.location.reload();
    } catch (e) {
      setError(e instanceof ApiError ? e.message : "작업 공간을 전환하지 못했습니다.");
      setSwitching(false);
    }
  };

  return (
    <div className="tenant-switcher">
      <label htmlFor="tenant-select" className="sr-only">
        작업 공간 선택
      </label>
      <select
        id="tenant-select"
        value={current?.id ?? ""}
        disabled={switching}
        onChange={(e) => void onSwitch(Number(e.target.value))}
      >
        {tenants.map((tenant) => (
          <option key={tenant.id} value={tenant.id}>
            {tenant.type === "PERSONAL" ? `${tenant.name} (개인)` : tenant.name}
          </option>
        ))}
      </select>
      {error && <span className="hint stat-alert">{error}</span>}
    </div>
  );
}

